import { createStore } from 'vuex'

// 创建状态管理实例
const store = createStore({
  state: {
    // 用户信息
    userInfo: null,
    // 令牌
    token: localStorage.getItem('token') || null,
    // 侧边栏展开状态
    sidebarOpened: true,
    // 加载状态
    loading: false
  },
  mutations: {
    // 设置用户信息
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    // 设置令牌
    setToken (state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    // 切换侧边栏状态
    toggleSidebar (state) {
      state.sidebarOpened = !state.sidebarOpened
    },
    // 设置加载状态
    setLoading (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    // 登录
    login ({ commit }, { token, userInfo }) {
      commit('setToken', token)
      commit('setUserInfo', userInfo)
    },
    // 登出
    logout ({ commit }) {
      commit('setToken', null)
      commit('setUserInfo', null)
    }
  },
  getters: {
    // 是否已登录
    isLoggedIn: state => !!state.token,
    // 获取用户信息
    userInfo: state => state.userInfo,
    // 获取令牌
    token: state => state.token,
    // 获取侧边栏状态
    sidebarOpened: state => state.sidebarOpened,
    // 获取加载状态
    loading: state => state.loading
  },
  modules: {
    // 可以根据需要拆分成多个模块
  }
})

export default store
